import { motion } from "framer-motion"
import type { CategoryCardProps } from "../../types/categories"

const CategoryCard: React.FC<CategoryCardProps> = ({ category, onTap, color }) => {
    return (
        <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="flex flex-col items-center p-2 sm:p-3 rounded-xl shadow-sm hover:shadow-md transition-all w-full"
            style={{ backgroundColor: color }}
            onClick={() => onTap(category)}
        >
            <motion.img
                whileHover={{ rotate: 5 }}
                src={category.image || "/default-category-image.png"}
                alt={category.name}
                className="w-8 h-8 sm:w-12 sm:h-12 rounded-full object-cover border border-solid-100 mb-1 sm:mb-2"
            />
            <span className="text-[10px] sm:text-xs font-medium text-content-default truncate w-full text-center">
                {category.name}
            </span>
        </motion.button>
    )
}

export default CategoryCard 